<script>
import axios from 'axios'
import DeviceIdModal from '@/vcs/_shared/modals/DeviceIdModal.vue'
import QrModal from '@/vcs/_shared/modals/QrModal.vue'
import LogModal from '@/vcs/_shared/modals/LogModal.vue'
import { mapGetters } from 'vuex'
import ModalMixin from '@/mixins/ModalMixin.js'

export default {
  name: 'SupportSettings',
  mixins: [ModalMixin],
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp'
    })
  },
  methods: {
    setDeviceId() {
      this.$store.commit('modal/open', {
        cmp: DeviceIdModal,
        canBackrdopClose: true
      })
    },
    scanQR() {
      this.$store.commit('modal/open', {
        cmp: QrModal,
        disableRedirect: true,
        size: 'full'
      })
    },
    openAllBoxesConfirmation() {
      this.openCloseLockerPromptModal(
        this.$t('support.settings.OPEN_LOCKERS_MESSAGE'),
        this.openAllBoxes,
        this.$t('yes'),
        this.$t('cancel')
      )
    },
    openAllBoxes() {
      this.$blockUI()
      axios({
        method: 'put',
        url: `/collection_points/${this.cp.id}/open_boxes`,
        headers: {
          common: {
            Authorization: `Bearer ${window.localStorage.getItem(
              'support_session_token'
            )}`
          }
        }
      })
        .then((response) => {
          this.$success(this.$t('success.allLockersOpened'))
        })
        .catch((error) => {
          this.$errorHumanized(null, this.$t('error.unableToOpenLockers'))
        })
        .finally(() => {
          this.$unblockUI()
        })
    },
    deleteDeviceId() {
      this.$store.commit('device_id', null)
      window.localStorage.removeItem('device_id')
      this.$router.push('/qr')
      location.reload()
    },
    kalbaczek() {
      console.log('witam jestem kalbaczkiem 🍆')
    },
    test() {
      this.openCloseLockerPromptModal(
        this.$t('support.settings.TEST_MESSAGE'),
        this.kalbaczek,
        this.$t('yes'),
        this.$t('cancel')
      )
    },
    showLogs() {
      this.$store.commit('modal/open', {
        cmp: LogModal,
        size: 'full'
      })
    },
    reloadApp() {
      this.$blockUI()
      let deviceId = window.localStorage.getItem('device_id')
      axios({
        method: 'get',
        url: `collection_points/${deviceId}/map`
      })
        .then((response) => {
          this.$store.commit('setCurrentCp', response.data)
        })
        .catch(() => {
          this.$errorHumanized(null, 'Something went wrong')
        })
        .finally(() => {
          this.$unblockUI()
          window.location.reload()
        })
    }
  }
}
</script>

<template lang="pug">
.route-view.container-fluid
  .row
    .col-12.col-lg-4.offset-lg-4.pt-5.pb-5
      button.btn.btn-primary.btn-block.mb-4(type="button" v-ea-click="reloadApp") Reload app
      button.btn.btn-primary.btn-block.mb-4(type="button" v-ea-click="setDeviceId") {{ $t('support.settings.setDeviceIdButton') }}
      button.btn.btn-primary.btn-block.mb-4(type="button" v-ea-click="deleteDeviceId") {{ $t('support.settings.deleteDeviceId') }}
      button.btn.btn-primary.btn-block.mb-4(type="button" v-ea-click="scanQR") {{ $t('support.settings.cameraTestButton') }}
      button.btn.btn-primary.btn-block.mb-4(
        type="button"
        v-ea-click="openAllBoxesConfirmation"
      ) {{ $t('support.settings.openAllLockers') }}
      button.btn.btn-primary.btn-block.mb-4(type="button" v-ea-click="showLogs") Show logs
      //- button.btn.btn-primary.btn-block.mb-4(
      //-   type="button"
      //-   v-ea-click="test"
      //- ) Test
</template>
